import { ITask } from '../tasksApi'
import IAttachment, { ICloudAttachment } from './attachment'
import { IQuestion } from './checklist'
import IContact from './contact'
import IUser from './user'

// box around the strokes of a signature (reports cut off the empty pad), in the SVG's units
export interface ISignatureBox {
  x: number
  y: number
  w: number
  h: number
  width: number
  height: number
}

export interface ISignature {
  id?: number | string
  user_id: number | null
  signature: IAttachment
  signature_box?: ISignatureBox | null
  display_user_name: string
  is_tester: boolean
  contact_id?: number
  contact?: IContact
  user?: IUser
  _dirty?: boolean
  user_name?: string
}

export interface IComment {
  id?: number | string
  text: string
  user?: IUser
  commentable?: IResult
  user_id?: number
  commentable_id: string
  _dirty?: boolean
  _destroy?: boolean
  commentable_type: string
  created_at?: Date
}

export interface IResultAttachementObject extends IAttachment {
  thumb?: IAttachment
  report?: IAttachment
}

export interface IResultAttachment {
  _destroy?: boolean
  id?: number
  attachment: IResultAttachementObject
  access_token?: string | null
  filename?: string
  mimetype?: string
}

type ActionType = 'set_question_value' | 'show_question' | 'hide_question' | 'show_area' | 'duplicate_area' | 'duplicate_question' | 'hide_area' | 'count_as_error' | 'create_task' | 'send_email';
export interface ResultAction {
  action: ActionType
  target_question_ids?: number[]
  target_area_ids?: number[]
  target_area_count?: number
  value?: string
  task_data?: any
  target_question_count?: number,
  area_position?: number
  message?: string
  area_info?: { area_id: string | number, area_position: number }
  origin_question?: IQuestion
}

export default interface IResult {
  _dirty?: boolean
  _new?: boolean
  _working?: boolean
  action?: ResultAction[]
  area_position: number
  attachments?: IResultAttachment[]
  audit_points: number
  // answer deviates from the expected answer or matches a "count as error" rule (set by the backend)
  deviation?: boolean
  cloud_attachments?: ICloudAttachment[]
  comments?: IComment[]
  contact_id?: number
  created_at?: Date
  id?: string
  option_text?: string | null
  question_id: number
  question_position: number
  question?: IQuestion
  result_set_id: number
  showCount?: number
  signature?: IAttachment
  signature_box?: ISignatureBox | null
  signee_name?: string
  signee?: string
  tasks?: ITask[]
  updated_at?: Date
  user_id?: number
  value: string | null
  versions: any[] // TODO: create type for version
}

export const numberValueFormat = /^[0-9_.,-]+$/
